export const RabValidationLabels = {
    deliveryType: { english: 'Delivery type', spanish: 'Tipo de parto' },
    hour: { english: 'Hour', spanish: 'Hora' },
    minute: { english: 'Minute', spanish: 'Minuto' },
    dateOfBirth: { english: 'Date of birth', spanish: 'Fecha de nacimiento' },
};
